import React, { FunctionComponent } from 'react'

import { useAuth } from 'modules/auth/hooks/auth'
import tmovLogo from 'shared/assets/images/tmovlogo.png'
import { numberToCurrency } from 'shared/utils/formatters'

import { useCartao } from '../../../hooks/useCartao'
import { Container, ContainerItem, Value, Label } from './styles'

const Cartao: FunctionComponent = () => {
  const { cartao } = useCartao()
  const { name } = useAuth()
  return (
    <Container>
      <ContainerItem>
        <Value>{cartao?.produto?.nome ? name : ' -'}</Value>
      </ContainerItem>
      <ContainerItem>
        <Label>
          Saldo
          <Value>
            {cartao?.saldo
              ? ` ${numberToCurrency(cartao?.saldo?.valor_saldo_disponivel)}`
              : ' R$ -'}
          </Value>
        </Label>
      </ContainerItem>
      <ContainerItem>
        <Label>
          Cartão
          <Value>
            {cartao?.identificador ? ` ${cartao?.identificador}` : ' -'}
          </Value>
        </Label>
      </ContainerItem>
      <ContainerItem>
        <img src={tmovLogo} alt="Imagem TMOV" />
      </ContainerItem>
    </Container>
  )
}

export default Cartao
